<template>
  <section>
    <m-img src="@/v2/mobile/assets/image/h_55.jpg"></m-img>
    <m-img src="@/v2/mobile/assets/image/h_56.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>
